<template>
  <!-- Page Container -->
  <div id="page-container" class="enable-page-overlay" :class="{'page-header-fixed page-header-dark sidebar-dark': showMenus(), 'sidebar-o': showSidebar && showMenus(), 'sidebar-o-xs': showSidebarXs && showMenus(), 'side-overlay-o': showSideOverlay}">

    <!-- Side Overlay-->
    <div @click="toggleSideOverlay" v-if="showSideOverlay" id="page-overlay"></div>
    <side-overlay/>
    <!-- END Side Overlay -->

    <!-- Sidebar -->
    <side-bar v-if="showMenus()" />
    <!-- END Sidebar -->

    <!-- Header -->
    <page-header v-if="showMenus()" />
    <!-- END Header -->

    <!-- Main Container -->
    <main id="main-container">

      <!-- Main View -->
      <router-view/>
      <!-- END Main View -->

    </main>
    <!-- END Main Container -->

    <!-- Footer -->
    <page-footer v-if="showMenus() && !['NetworkGraphNetwork'].includes(this.$route.name)"/>
    <!-- END Footer -->
    <notification/>
    <pp-modal/>
  </div>
  <!-- END Page Container -->
</template>

<script>
import { mapMutations } from 'vuex'
import sideOverlay from './components/layout/sideOverlay.vue'
import sideBar from './components/layout/sideBar.vue'
import pageHeader from './components/layout/pageHeader.vue'
import pageFooter from './components/layout/pageFooter.vue'
import ppModal from './views/legal/pp'
import notification from './components/layout/notification'

const fb = require('@/firebaseConfig.js')

export default {
  components: {
    sideOverlay,
    sideBar,
    pageHeader,
    pageFooter,
    ppModal,
    notification
  },
  created () {
    fb.auth.onAuthStateChanged(user => {
      this.$store.dispatch('setCurrentUser', user)
    })
  },
  computed: {
    showSidebar () {
      return this.$store.state.options.showSidebar
    },
    showSidebarXs () {
      return this.$store.state.options.showSidebarXs
    },
    showSideOverlay () {
      return this.$store.state.options.showSideOverlay
    }
  },
  methods: {
    ...mapMutations([
      'toggleSideOverlay'
    ]),
    showMenus () {
      return !(['welcome', 'login', 'register', 'pwreset', 'verifyemail'].includes(this.$route.name))
    }
  }
}
</script>

<style lang="scss">
  // import main styles
  @import 'assets/_scss/main';
  @import 'assets/_scss/core/themes/xwork';
</style>
